import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetControlPrograms } from "api/generated/control-program/control-program";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useControlProgramOverviewsQuery(enabled: boolean) {
    return useGetControlPrograms(undefined, {
        query: {
            ...CONTROL_LIST_QUERY_OPTIONS,
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
            enabled,
        },
    });
}
